import { SendGridEmailStatus, useSendGridEmailLogWidgetQuery } from 'generated/graphql';
import _ from 'lodash';
import { DateTime } from 'luxon';
import React from 'react';


export interface SendGridEmailRequest {
  id: string;
  createdAt: DateTime;
  orderId?: string | undefined | null;
  returnAuthorizationId?: string | undefined | null;
  recipientEmails: string[];
  status: SendGridEmailStatus;
  appEvent?: string | null;
  errorReason?: string | null;
}

export interface IData {
  sendGridEmailRequests: SendGridEmailRequest[];
}


export function useQuery({
  orderId, returnAuthorizationId
}: {
  orderId?: string;
  returnAuthorizationId?: string;
}) {

  const tuple = useSendGridEmailLogWidgetQuery({
    fetchPolicy: 'network-only',
    variables: {
      options: {
        filter: {
          orderId: orderId || null,
          returnAuthorizationId: returnAuthorizationId || null
        }
      }
    }
  });

  return React.useMemo(() => {
    const nodes = tuple?.data?.sendGridEmailRequests?.nodes || [];
    const data: IData = {
      sendGridEmailRequests: _.map(nodes, (node): SendGridEmailRequest => ({
        id: node.id,
        status: node.status,
        orderId: node.orderId,
        appEvent: node.appEvent?.displayName,
        recipientEmails: node.recipientEmails,
        createdAt: DateTime.fromISO(node.createdAt),
        returnAuthorizationId: node.returnAuthorizationId,
        errorReason: node.errorReason
      }))
    };
    return {
      ...tuple,
      data
    };
  }, [tuple]);
}

